import React, { useEffect, useState } from 'react';
import {
  Phone, Mail, Plus, ChevronRight, User, Calendar, Paperclip,
  CheckCircle, Headphones, ArrowLeft, XCircle
} from 'lucide-react';

import './dashboard.css';
import { useDispatch, useSelector } from "react-redux";
import { fetchStates, fetchDistricts } from "../../../features/master/masterThunks";
import {
  fetchSupportCategories,
  fetchMyTickets,
  createSupportTicket,
  fetchSupportContact
} from "../../../features/user/supportThunks";
import { toast } from "react-toastify";

export default function EnhancedSupportUI() {
  const dispatch = useDispatch();

  const {
    supportContact,
    categories,
    myTickets,
    loadingCategories,
    loadingTickets,
    creating,
    createError
  } = useSelector((state) => state.support);
const { states, districts } = useSelector((state) => state.master);
const [selectedState, setSelectedState] = useState("");
const [selectedDistrict, setSelectedDistrict] = useState("");
  const [activeTab, setActiveTab] = useState('create');
  const isLocationSelected = Boolean(selectedState && selectedDistrict);
const isContactLoading =
  isLocationSelected && !supportContact;
const isContactFound = Boolean(supportContact);
  const [showTicketForm, setShowTicketForm] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const [formData, setFormData] = useState({
    subject: '',
    categoryId: '',
    description: ''
  });

useEffect(() => {
  dispatch(fetchStates("68e8ef76a65b0a7d7ec75a29")); // use actual countryId
}, [dispatch]);
useEffect(() => {
  if (selectedState) {
    dispatch(fetchDistricts(selectedState));
    setSelectedDistrict("");
  }
}, [selectedState, dispatch]);

useEffect(() => {
  if (selectedState && selectedDistrict) {
    dispatch(
      fetchSupportContact({
        stateId: selectedState,
        districtId: selectedDistrict,
      })
    );
  }
}, [selectedState, selectedDistrict, dispatch]);


  // Load categories and user's tickets on mount
  useEffect(() => {
    dispatch(fetchSupportCategories());
    dispatch(fetchMyTickets());
    dispatch(fetchSupportContact());
  }, [dispatch]);

  // Toast Errors
  useEffect(() => {
    if (createError) toast.error(createError);
  }, [createError]);

  const handleSubmit = async () => {
    if (!formData.subject || !formData.categoryId || !formData.description) {
      toast.error("All fields are required");
      return;
    }

    const data = new FormData();
    data.append("title", formData.subject);
    data.append("categoryId", formData.categoryId);
    data.append("description", formData.description);
    if (attachment) data.append("image", attachment);

    const res = await dispatch(createSupportTicket(data));

    if (createSupportTicket.fulfilled.match(res)) {
      toast.success("Ticket created successfully!");
      setFormData({ subject: "", categoryId: "", description: "" });
      setAttachment(null);
      setShowTicketForm(false);
      setActiveTab("open");
    }
  };

  
const openTickets = myTickets.filter(
  t => t.ticketStatus?.toLowerCase() !== "closed"
);

const closedTickets = myTickets.filter(
  t => t.ticketStatus?.toLowerCase() === "closed"
);


  // UI Helpers -----------------------

  const renderCreateTicketInitialState = () => (
    <>
      <div className="support-hero">
        <div className="support-hero-icon">
          <Headphones size={40} />
        </div>
        <h2 className="support-hero-title">How can we help you?</h2>
        <p className="support-hero-subtitle">
          Submit a ticket and our support team will get back to you within 24 hours.
        </p>

        <button className="primary-btn mt-5" onClick={() => setShowTicketForm(true)}>
          <Plus size={20} />
          Create New Ticket
        </button>
      </div>

      {/* Quick Support */}

    {/* LOCATION FILTERS */}
<div className="location-card">
  <h4 className="location-title">Select Your Location</h4>

  <div className="location-filters">
    <select
      className="form-select"
      value={selectedState}
      onChange={(e) => setSelectedState(e.target.value)}
    >
      <option value="">Select State</option>
      {states.map((s) => (
        <option key={s._id} value={s._id}>{s.name}</option>
      ))}
    </select>

    <select
      className="form-select"
      value={selectedDistrict}
      disabled={!selectedState}
      onChange={(e) => setSelectedDistrict(e.target.value)}
    >
      <option value="">Select District</option>
      {districts.map((d) => (
        <option key={d._id} value={d._id}>{d.name}</option>
      ))}
    </select>
  </div>
</div>

{/* SUPPORT CONTACTS */}
<div className={`help-card ${!isContactFound ? "disabled" : ""}`}>
  <div className="help-icon"><Phone size={24} /></div>

  <div className="help-info">
    <h4 className="help-title">Call Support</h4>

    {!isLocationSelected && (
      <p className="help-muted">Select state & district</p>
    )}

    {isContactLoading && (
      <p className="help-loading">Fetching contact…</p>
    )}

    {isContactFound && (
      <>
        <p className="help-detail">{supportContact.mobile}</p>
          <p className="help-detail text-sm">Availability: From 10 AM to 5 PM, Mon to Friday</p>
      </>
    )}
  </div>

  <ChevronRight size={20} />
</div>

<div className={`help-card ${!isContactFound ? "disabled" : ""}`}>
  <div className="help-icon"><Mail size={24} /></div>

  <div className="help-info">
    <h4 className="help-title">Email Support</h4>

    {!isLocationSelected && (
      <p className="help-muted">Select state & district</p>
    )}

    {isContactLoading && (
      <p className="help-loading">Fetching email…</p>
    )}

    {isContactFound && (
      <p className="help-detail">{supportContact.email}</p>
    )}
  </div>

  <ChevronRight size={20} />
</div>


    </>
  );

  const renderTicketForm = () => (
    <div>
      <h2 className="section-title mb-4">Submit a New Support Request</h2>

      {/* Subject */}
      <div className="form-group">
        <label className="form-label">Subject *</label>
        <input
          type="text"
          className="form-input"
          value={formData.subject}
          placeholder="Enter issue title"
          onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
        />
      </div>

      {/* Category */}
      <div className="form-group">
        <label className="form-label">Category *</label>

        <select
          className="form-select"
          value={formData.categoryId}
          onChange={(e) => setFormData({ ...formData, categoryId: e.target.value })}
        >
          <option value="">Select Category</option>

          {loadingCategories ? (
            <option>Loading...</option>
          ) : (
            categories.map((cat) => (
              <option key={cat._id} value={cat._id}>{cat.name}</option>
            ))
          )}
        </select>
      </div>

      {/* Description */}
      <div className="form-group">
        <label className="form-label">Description *</label>
        <textarea
          className="form-textarea"
          value={formData.description}
          placeholder="Explain your issue clearly"
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        />
      </div>

      {/* Attachment */}
      <div className="form-group">
        <label className="form-label">Attachment (Optional)</label>
        <input
          type="file"
          className="hidden-file-input"
          id="file-upload"
          onChange={(e) => setAttachment(e.target.files[0])}
        />
        <label htmlFor="file-upload" className="custom-file-label">
          <Paperclip size={16} /> Choose File
        </label>
        <span className="file-name">
          {attachment ? attachment.name : "No file selected"}
        </span>
      </div>

      {/* Buttons */}
      <div className="btn-group">
        <button className="btn-secondary" onClick={() => setShowTicketForm(false)}>
          Cancel
        </button>

        <button className="primary-btn" onClick={handleSubmit} disabled={creating}>
          {creating ? "Submitting..." : "Submit Ticket"}
        </button>
      </div>
    </div>
  );

  const renderTicketsList = (list, type) => (
    <>
      <h2 className="section-title mb-4">
        {type === 'open' ? "Your Active Tickets" : "Your Closed Tickets"}
      </h2>

      {loadingTickets ? (
        <p>Loading Tickets...</p>
      ) : list.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">
            {type === 'open' ? <XCircle size={36} /> : <CheckCircle size={36} />}
          </div>
          <p className="empty-text">
            {type === 'open'
              ? "No open tickets right now."
              : "No closed tickets."}
          </p>
        </div>
      ) : (
        list.map((ticket) => (
          <div key={ticket._id} className="ticket-card clickable">
            <div className="ticket-header">
              <span className="ticket-id">#{ticket._id.slice(-6)}</span>
              <span className={`ticket-status ${ticket.ticketStatus?.toLowerCase()}`}>
           {ticket.ticketStatus}
          </span>
            </div>

            <h3 className="ticket-title">{ticket.title}</h3>

            <div className="ticket-meta">
              <div className="ticket-meta-item">
                <User size={14} /> {ticket.categoryId?.name}
              </div>

              {ticket.image && (
                <div className="ticket-meta-item">
                  <Paperclip size={14} />
                  Attachment
                </div>
              )}

              <div className="ticket-meta-item">
                <Calendar size={14} /> {new Date(ticket.createdAt).toDateString()}
              </div>
            </div>
          </div>
        ))
      )}
    </>
  );

  // MAIN RENDER -------------------------
  const renderContent = () => {
    if (activeTab === 'create') return showTicketForm ? renderTicketForm() : renderCreateTicketInitialState();
    if (activeTab === 'open') return renderTicketsList(openTickets, 'open');
    if (activeTab === 'closed') return renderTicketsList(closedTickets, 'closed');
  };

  return (
    <div className="overview-container dashboard-light-bg">
      <div className="desktop-container">

        {/* Sidebar Tabs */}
        <div className="tabs">
          <h2 className="section-title" style={{ padding: "0 24px 20px" }}>
            Support Center
          </h2>

          <button className={`tab ${activeTab === 'create' ? 'active' : ''}`}
            onClick={() => { setActiveTab('create'); setShowTicketForm(false); }}>
            Create Ticket
          </button>

          <button className={`tab ${activeTab === 'open' ? 'active' : ''}`}
            onClick={() => { setActiveTab('open'); }}>
            Open ({openTickets.length})
          </button>

          <button className={`tab ${activeTab === 'closed' ? 'active' : ''}`}
            onClick={() => { setActiveTab('closed'); }}>
            Closed ({closedTickets.length})
          </button>
        </div>

        {/* Main Content */}
        <div className="main-content-area">
          {renderContent()}
        </div>
      </div>
      <style jsx>{`
      .location-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
}

.location-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
}

.location-filters {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 640px) {
  .location-filters {
    grid-template-columns: 1fr;
  }
}

.help-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
}

.help-card.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.help-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5b4ef3;
}

.help-info {
  flex: 1;
  margin-left: 12px;
}

.help-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.help-detail {
  font-size: 14px;
  color: #111;
}

.help-muted {
  font-size: 13px;
  color: #888;
}

.help-loading {
  font-size: 13px;
  color: #5b4ef3;
  font-weight: 500;
}

      `}</style>
    </div>
  );
}
